/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { Button, WizardStepProps } from '@squiz/sds';
import { getTenantFromUrl } from 'apps/console-core/src/Utilities/GetTenantFromUrl/GetTenantFromUrl';
import React, { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { FILE_EXPLORER_STRINGS } from '../../../../FileExplorer.constants';

export const RemainingItemsDialogContent = (props: WizardStepProps): JSX.Element => {
  const { close, customProps, setButtons, setButtonKeys } = props;
  const { t } = useTranslation();
  const tenant = getTenantFromUrl();

  const labels = useMemo(() => {
    return {
      followingFilesNotDeleted: t(FILE_EXPLORER_STRINGS.followingFilesNotDeleted),
      ok: t(FILE_EXPLORER_STRINGS.ok),
      remainingItems: t(FILE_EXPLORER_STRINGS.remainingItems),
    };
  }, [t]);

  const { errors } = customProps as { errors: Array<{ source: string }> };

  useEffect(() => {
    const okButton = <Button classes="ok-button" onClick={(): void => close()} text={labels.ok} />;

    setButtonKeys([`ok`]);
    setButtons([okButton]);
  }, [close, labels, setButtonKeys, setButtons]);

  return (
    <div className="file-explorer__dialog-content delete-step-2">
      <div className="sds-dialog__heading custom">
        <span>{labels.remainingItems}</span>
      </div>
      <p className="file-explorer__dialog-text">{labels.followingFilesNotDeleted}</p>
      <ul className="file-explorer__dialog-list">
        {errors.map((err) => (
          <li key={err.source}>{err.source.replace(tenant, '')}</li>
        ))}
      </ul>
    </div>
  );
};
